module.exports = __webpack_public_path__ + "img/tierwohl_negativ.2782acd9.png";